import { render, staticRenderFns } from "./OrdersStatSenior.vue?vue&type=template&id=894a7cdc&"
import script from "./OrdersStatSenior.vue?vue&type=script&lang=js&"
export * from "./OrdersStatSenior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports